import React from 'react'

export const UploadIcon = () => (
  <svg width='38' height='49' viewBox='0 0 38 49' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g opacity='0.15'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M23.75 0.50049V9.13695C23.75 11.1531 23.75 12.1612 24.1383 12.9313C24.4798 13.6086 25.0248 14.1594 25.6951 14.5045C26.4572 14.8969 27.4547 14.8969 29.4499 14.8969H37.9961L37.9992 14.9V36.98C37.9992 41.0124 37.9992 43.0286 37.2227 44.5687C36.5396 45.9235 35.4496 47.025 34.109 47.7152C32.5849 48.5 30.5898 48.5 26.5995 48.5H11.3998C7.40947 48.5 5.41433 48.5 3.89024 47.7152C2.54961 47.025 1.45965 45.9235 0.776563 44.5687C0 43.0286 0 41.0124 0 36.98V12.02C0 7.98762 0 5.97143 0.776563 4.43127C1.45965 3.0765 2.54961 1.97504 3.89024 1.28475C5.41433 0.5 7.40947 0.5 11.3998 0.5H23.7495L23.75 0.50049Z'
        fill='#0246F8'
      />
      <path
        d='M26.125 9.30004V1.03906V0.5L37.9998 12.4999L37.4665 12.5H29.2916C28.1832 12.5 27.629 12.5 27.2056 12.282C26.8332 12.0903 26.5305 11.7843 26.3407 11.408C26.125 10.9802 26.125 10.4201 26.125 9.30004Z'
        fill='#0246F8'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M31.2292 39.2529L19.0022 26.897L6.77522 39.2529C6.02537 40.0107 6.56213 41.297 7.62818 41.297H14.2558V48.497H23.7556V41.297H30.3762C31.4423 41.297 31.979 40.0107 31.2292 39.2529Z'
        fill='white'
      />
    </g>
  </svg>
)
